import { ConfigOption } from "@ngx-formly/core";

import {
  FormlyFieldButton,
  FormlyFieldInputButton,
  FormlyFieldRadio,
  FormlyFieldIterate,
  FormlyFieldEpRadio,
  EPTemplate,
  EPText
} from "./index";

export const CUSTOM_FIELD_TYPE_COMPONENTS = [
  FormlyFieldButton,
  FormlyFieldInputButton,
  FormlyFieldRadio,
  FormlyFieldIterate,
  FormlyFieldEpRadio,
  EPTemplate,
  EPText
];

export const CUSTOM_FORMLY_CONFIG: ConfigOption = {
  types: [
    {
      name: "ep-template",
      component: EPTemplate
    },
    {
      name: "ep-button",
      component: FormlyFieldButton,
      defaultOptions: {
        templateOptions: {
          btnType: "default",
          type: "button"
        }
      }
    },
    {
      name: "ep-radio",
      component: FormlyFieldRadio,
      defaultOptions: {
        key: "model",
        templateOptions: {
          style: "radio-change",
          fieldName: ""
        }
      }
    },
    {
      name: "ep-for",
      component: FormlyFieldIterate,
      defaultOptions: {
        templateOptions: {}
      }
    },
    {
      name: "ep2-radio",
      component: FormlyFieldEpRadio
    }
  ],
  validationMessages: [
    { name: "required", message: getRequiredValidationMessage },
    { name: "atLeastOneFieldRequired", message: getAtLeastOneFieldRRequiredValidationMessage },
    { name: "invalidEmailAddress", message: "Invalid Email Address" },
    { name: "maxlength", message: "Maximum Length Exceeded." },
    { name: "minlength", message: getMinLengthValidationMessage },
    { name: "not_matching", message: "Password Not Matching" },
    { name: "zipCode", message: "ZIP code should be 5 characters" },
    { name: "uniqueUsername", message: "This username is already taken." }
  ]
};

export function getRequiredValidationMessage(err, field): string {
  return `${field.templateOptions.label} is required.`;
}

export function getAtLeastOneFieldRRequiredValidationMessage(err, field): string {
  return `At least one ${field.templateOptions.label} is required.`;
}

export function getMinLengthValidationMessage(err): string {
  return `Should have at least ${err.requiredLength} Characters`;
}
